<template>
    <div style="background-color: #fff">
        <div class="pt-3 pt-3">
            <el-divider content-position="left"> 订阅权限:
            </el-divider>
        </div>
        <div class="mt-1">
            <my-table :data="auth.normal" :fields="normalFields">
                <el-table-column slot="operation" width="150" label="操作">
                    <template slot-scope="scope">
                        <!--                        <span class="my-sort-dom" :data-id="scope.row.product_id">-->
                        <!--                            <i class="el-icon-rank"></i>-->

                        <!--                        </span>-->
                        <!--                        <el-button-->
                        <!--                            size="mini"-->
                        <!--                            :data-id="scope.row.product_id"-->
                        <!--                            class="my-sort-dom"-->
                        <!--                            v-access="{url:baseUrl,method:'PUT'}"-->
                        <!--                            icon="el-icon-rank">-->
                        <!--                        </el-button>-->
                        <el-button
                            size="mini"
                            type="primary"
                            @click="renewProduct(2)" v-if="[2].indexOf(scope.row.level)>-1"
                            icon="el-icon-goods">续费
                        </el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="pt-3 pt-3">
            <el-divider content-position="left"> 我的公司:

            </el-divider>
        </div>
        <div class="mt-1">
            <my-table :data="netAuth" :fields="netFields">
                <template v-slot:nickname="nickname">
                    <el-link type="primary" v-if="!nickname.data" @click="editNickname(nickname)">添加备注</el-link>
                    <span v-else>{{nickname.data}}</span>
                </template>
                <el-table-column slot="operation" width="220" label="操作">
                    <template slot-scope="scope">
                        <!--                        <span class="my-sort-dom" :data-id="scope.row.product_id">-->
                        <!--                            <i class="el-icon-rank"></i>-->

                        <!--                        </span>-->
                        <!--                        <el-button-->
                        <!--                            size="mini"-->
                        <!--                            :data-id="scope.row.product_id"-->
                        <!--                            class="my-sort-dom"-->
                        <!--                            v-access="{url:baseUrl,method:'PUT'}"-->
                        <!--                            icon="el-icon-rank">-->
                        <!--                        </el-button>-->
                        <el-button
                            size="mini"
                            type="primary"
                            @click="renewProduct(3)"
                            icon="el-icon-goods">续费
                        </el-button>
                        <el-button
                            :type="scope.row.is_default?'danger':'primary'"
                            size="mini"
                            @click="deleteCompany(scope.$index,scope.row)" v-access="{url:baseUrl,method:'PUT'}"
                            :icon="scope.row.is_default?'el-icon-remove':'el-icon-plus'">{{scope.row.is_default?'解绑企业':'加入企业'}}</el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <form-dialog @closeFormDialog="submit" :title="form.title" :show="form.show" :fields="form.fields"
                     :rules="form.rules" :data="form.data"></form-dialog>
        <buy-dialog @close="buy_show=false" :level="buy_level" :show="buy_show"></buy-dialog>
    </div>
</template>
<script>
import F from '@/fields/fields';
import BuyDialog from "@/components/user/buy/buy-dialog.vue";
import MyTable from "@/components/common/my-table";

export default {
    components: {
        MyTable, BuyDialog
    },
    created() {

    },
    mounted() {
        this.search();
    },
    data: function () {
        return {
            baseUrl: '/bbs/pay/auth',
            buy_show: false,
            buy_level:2,
            page: {
                search: {},
                sort: {},
                total: 1,
                pageSize: 15,
                pageNumber: 1,
            },
            auth: {
                normal: [],
                net: [],
            },
            form: {
                action_name: '',
                show: false,
                title: '',
                data: {},
                fields: [],
                rules: {},
            }
        }
    },
    watch: {},
    computed: {
        normalFields: function () {
            return F.show('proAuthInfo', 'vip_show');
        },
        netFields: function () {
            return F.show('proAuthInfo', 'net_show');
        },
        netAuth: function () {
            return this.auth.net.map(v => {
                v.company_name_alias = v.company && v.company.company_name_alias;
                v.start_time = v.company && v.company.start_time;
                v.end_time = v.company && v.company.end_time;
                return v;
            });
        }
    },
    methods: {
        search: function () {
            this.$bbs.get(this.baseUrl, {
                params: this.page,
                need: {
                    error: true,
                }
            }).then(data => {
                //将订阅版放前面
                this.auth.normal = data.data.normal.sort((a, b) => {
                    return a.level > b.level ? -1 : 1;
                });
                this.auth.net = data.data.net;
            });
        },
        sortChange: function (column) {
            if (!column.order) return;
            this.page.sort = {prop: column.prop, order: column.order};
            this.search();
        },
        sizeChange: function (size) {
            this.page.pageSize = size;
            this.search();
        },
        pageChange: function (page) {
            this.page.pageNumber = page;
            this.search();
        },
        filterPlatform(value, row) {
            return row.tag === value;
        },
        submit: function (data) {
            // this.con(data);
            if (data.type === 'cancel') {
                this.form.show = false;
                return;
            }
            switch (this.actionName) {
                case 'editNickname':
                    this.$bbs.put(this.baseUrl, data.data, {
                        need: {
                            error: true,
                        }
                    }).then(adData => {
                        this.$message.success('操作成功');
                        this.search();
                        this.form.show = false;
                    });
                    break;
                case 'addUser':
                    this.$bbs.post(this.baseAddUrl, data.data, {
                        need: {
                            error: true,
                        }
                    }).then(userData => {
                        this.page.total++;
                        this.form.show = false;
                        let index = this.company.list[this.company.index].users.findIndex(v => v.username === userData.data.username);
                        if (index === -1) {
                            this.$message.success('添加成功!');
                            this.company.list[this.company.index].users.unshift(userData.data);
                        } else {
                            this.$message.warning('存在此用户!');
                        }
                    });
                    break;
                case 'editUser':
                    //这里添加这个变量，方便后台判断是哪里来的修改操作，方便判断
                    data.data.from_type = this.my_net_type;
                    data.data.net_id = this.company.current.net_id;
                    this.$bbs.put(this.baseAddUrl, data.data, {
                        need: {
                            error: true,
                        }
                    }).then(userData => {
                        this.form.show = false;
                        this.$message.success('修改成功!');
                        //先获取原来的旧数据
                        let old_data = this.company.list[this.company.index].users[this.index];
                        //还原对应的手机号和公司的名称
                        userData.data.phone = old_data.phone;
                        userData.data.company_name_alias = old_data.company_name_alias;
                        this.company.list[this.company.index].users.splice(this.index, 1, userData.data);
                    });
                    break;
            }
        },
        renewProduct(level) {
            this.buy_level=level;
            this.buy_show = true;
        },
        editNickname: function (data) {
            //因为我设置了只有选中的时候，才可以编辑，所以这里直接使用 this.company.current,this.company.index
            let form = F.get('proAuthInfo', 'edit_nickname', {mapping_id:data.all.mapping_id});
            this.actionName = 'editNickname';
            this.form = form;
        },
        deleteCompany: function (index, data) {
            let net_id=this.netAuth[index].net_id;
            if (data.is_default){
                this.$confirm('解绑企业，将丢失企业的会员权益，是否确认解绑?', '操作确认').then(() => {
                    this.$bbs.delete(this.baseUrl, {data: {id:data.mapping_id,net_id}}).then(() => {
                        this.$message.success('解绑成功!');
                        this.search();
                    });
                });
            }else{
                this.$bbs.delete(this.baseUrl, {data: {id:data.mapping_id,net_id}}).then(() => {
                    this.$message.success('加入成功!');
                    this.search();
                });
            }

            // this.$confirm('退出企业，将丢失企业的会员权益，并且不能主动加入，是否确认退出?', '操作确认').then(() => {
            //     this.$bbs.delete(this.baseUrl, {data: {id}}).then(() => {
            //         this.$message.success('删除成功!');
            //         this.search();
            //     });
            // });
        }
    }
}
</script>

<style lang="less" scoped>

</style>
